import { clientWithCredentials } from "../_helpers";
import { systemsConstants, alertConstants } from "../_constants";

export const systemsAction = {
    loadSystems
};

function loadSystems() {
    return function(dispatch:any) {
        dispatch({
            type: systemsConstants.SYSTEMS_LOADING
        });
        clientWithCredentials(dispatch).get("api/system")
            .then((data) => {
                dispatch({
                    type: systemsConstants.SYSTEMS_LOADED,
                    data: data.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: systemsConstants.SYSTEMS_ERROR
                });
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.message,
                        level: "error"
                    }
                });
            })
    };
}